module.exports = ".kan-dog-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/dog-dialog/component.scss
// module id = ./src/modules/admin/dialogs/dog-dialog/component.scss
// module chunks = main